/**
 * Redacted Value (piece 3): the browser receives a string composed on the
 * server, dots with a short tail, and renders exactly that. The client holds
 * no other digits and slices nothing. `revealTail` is an argument the caller
 * takes from the field's ConfidentialFieldDisclosure row once that piece lands.
 */
export const REDACTION_DOT = '•';

const COMPOSED = new RegExp(`^${REDACTION_DOT}+[^${REDACTION_DOT}]*$`);

/** True for a string that is dots followed by a tail with no dot in it, the only shape the component accepts. */
export function isComposedRedaction(text: string): boolean {
  return COMPOSED.test(text);
}

export function redactedTail(text: string): string {
  return text.replace(new RegExp(`^${REDACTION_DOT}+`), '');
}

export function assertComposedRedaction(text: string): void {
  if (!isComposedRedaction(text)) {
    throw new Error('Redacted Value renders a server-composed dots-and-tail string and nothing else (piece 3)');
  }
}

/**
 * Dots then a tail of `revealTail` characters. The server composes this for a
 * stored value and the browser never holds the rest; a confidential Formatted
 * Input composes it for the value the person is typing, which they hold anyway.
 */
export function composeRedaction(value: string, revealTail: number): string {
  const tail = Math.max(0, Math.min(Math.trunc(revealTail), value.length));
  const hidden = value.length - tail;
  return REDACTION_DOT.repeat(Math.max(hidden, 1)) + (tail > 0 ? value.slice(value.length - tail) : '');
}
